import { render, staticRenderFns } from "./InstructionsTab.vue?vue&type=template&id=68a7dcd3"
import script from "./InstructionsTab.vue?vue&type=script&lang=js"
export * from "./InstructionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports